import { render, staticRenderFns } from "./constructionRelactionTaskTbm.vue?vue&type=template&id=7f35f3ad"
import script from "./constructionRelactionTaskTbm.vue?vue&type=script&lang=js"
export * from "./constructionRelactionTaskTbm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f35f3ad')) {
      api.createRecord('7f35f3ad', component.options)
    } else {
      api.reload('7f35f3ad', component.options)
    }
    module.hot.accept("./constructionRelactionTaskTbm.vue?vue&type=template&id=7f35f3ad", function () {
      api.rerender('7f35f3ad', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/scm/constructionRelactionTaskTbm.vue"
export default component.exports